exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application--wrap[data-v-295e3294]{min-height:80vh!important}.card_number[data-v-295e3294]{font-size:110px!important}", ""]);

// exports
